import { Controller } from "@hotwired/stimulus";

export default class LinkController extends Controller {

  async navigate(event) {
    const selection = globalThis.getSelection();
    if (selection && !selection.isCollapsed) {
      return;
    }

    // access the post description link without open the show page
    if (event.target.classList?.contains("skip-navigation") || event.target.closest(".skip-navigation") || event.target.classList.contains("post-media-arrow") || event.target.classList.contains("slick-dots")) {
      return;
    }

    if (event.target.tagName === "IMG") {
      return;
    }

    if (event.target.closest("a") || event.target.closest(".slick-dots")) {
      return;
    }

    if (event.target.closest(".no-link-navigation")) {
      return;
    }
    if (event.target.closest(".poll_voters")) {
      return;
    }

    if (event.target.closest(".inner-link")) {
      return;
    }

    if (event.target.closest(".dropdown")) {
      return;
    }

    event.preventDefault();

    const href = this.element.getAttribute("href");
    const turbo = this.element.dataset.turbo;

    const turboRequest = (await import("../helpers/api")).turboRequest;

    if (turbo === "true") {
      await turboRequest(href, {
        method: "GET",
        turboStream: true
      });
      return;
    }

    if (href) {
      Turbo.visit(href);
    }
  }
}
